import { makeStyles, createStyles } from '@material-ui/core';

export const useStylesProducView = makeStyles(theme =>
  createStyles({
    editor: {
      boxShadow: 'initial !important',
      padding: '0 !important',
    },
    container: {
      padding: '0',

      [theme.breakpoints.up('md')]: {
        padding: '0 22px',
      },
    },
    card: {
      padding: '10px',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',

      [theme.breakpoints.up('md')]: {
        padding: '55px',
      },
    },
    leftCol: {
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '65%',
      },
    },
    rightCol: {
      width: '100%',

      [theme.breakpoints.up('md')]: {
        width: '30%',
      },
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      // marginTop: 25,
      marginBottom: 30,
    },
    name: {
      fontSize: 25,

      fontWeight: 'bold',
      margin: 0,

      [theme.breakpoints.up('md')]: {
        fontSize: 20,
      },
    },
    price: {
      color: '#7e8299',
      fontSize: 22,
      fontWeight: 600,
      margin: 0,

      [theme.breakpoints.up('md')]: {
        fontSize: 16,
      },
    },
    whatsAppButton: {
      width: '100%',
      height: 42,
      padding: '12px 20px',
      borderRadius: 4,
      backgroundColor: '#25d366',
      fontSize: 14,
      fontWeight: 'bold',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      textAlign: 'center',
      color: '#fff',
      display: 'inline-block',
      marginTop: 20,

      '&:hover': {
        color: '#fff',
      },

      [theme.breakpoints.up('md')]: {
        width: 215,
      },
    },
    listItem: {
      marginBottom: 15,
    },
    listValue: {
      fontSize: 19,
      fontWeight: 600,
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 'normal',
      letterSpacing: 'normal',
      color: '#3f4254',
      marginBottom: 5,
    },
    listKey: {
      marginBottom: 0,
    },
    companyCard: {
      padding: '25px 30px',
      borderRadius: '4px',
      backgroundColor: '#f5f8fa',
      marginTop: 30,
    },
  })
);
